import React from 'react';
import { Box } from '@mui/material';
import { useRoomBannerStyles } from '../../../lib/hook/useRoomBannerStyles';

interface Props {
  className?: string;
  image: string;
}

const RoomBanner: React.FC<Props> = (props: Props) => {
  const roomBannerClasses = useRoomBannerStyles();

  const { className, image } = props;

  return (
    <Box className={className}>
      <img alt="room-banner" className={roomBannerClasses.root} src={image} />
    </Box>
  );
};

export default RoomBanner;
